/* ==========================================================================
   PRODUCT BUBBLE — magic chime + click burst
   • Web Audio API: arpeggio di sine waves (5 note ascending) — diverso dal
     chime dei social icons per varietà sonora.
   • Click sul card-gallery / product-media-container:
       1. Riproduce il chime
       2. Aggiunge classe .product-bubble--clicked per 700ms (CSS burst)
       3. Inietta data-magic-sparkle sull'host così magic.js lancia gli sparkles
   ========================================================================== */

(function () {
  'use strict';

  if (typeof document === 'undefined') return;
  if (window.__productBubbleBound) return;
  window.__productBubbleBound = true;

  // Preferenze utente
  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Web Audio chime ──────────────────────────────────────────── */
  var actx = null;

  function getCtx() {
    if (actx) return actx;
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try { actx = new AC(); } catch (e) { return null; }
    return actx;
  }

  /**
   * Magic chime: arpeggio di 5 sine waves ascendenti
   * (E5, G5, B5, E6, G6 — accordo di Mi minore, ottave miste).
   * Ogni nota parte sfasata di 35ms → effetto "scintilla che sale".
   * Decay esponenziale 800-1200ms.
   */
  function playChime() {
    var ac = getCtx();
    if (!ac) return;
    if (ac.state === 'suspended') {
      try { ac.resume(); } catch (e) { /* ignore */ }
    }
    var now = ac.currentTime;
    var freqs = [659.25, 783.99, 987.77, 1318.51, 1567.98];
    for (var i = 0; i < freqs.length; i++) {
      var osc = ac.createOscillator();
      var gain = ac.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freqs[i], now);
      var start = now + i * 0.035;
      var peak = 0.09 - i * 0.012;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(peak, start + 0.005);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.85 + i * 0.06);
      osc.connect(gain).connect(ac.destination);
      osc.start(start);
      osc.stop(start + 1.0 + i * 0.06);
    }
  }

  /* ── Click handler ────────────────────────────────────────────── */

  /**
   * Trova l'host del bubble (card-gallery o product-media-container)
   * a partire dal nodo cliccato. Risale al più vicino antenato che ha
   * la classe target.
   */
  function findBubbleHost(el) {
    if (!el || !el.closest) return null;
    return el.closest('.product-card .card-gallery');
  }

  function flashBubble(host) {
    if (!host) return;
    host.classList.remove('product-bubble--clicked');
    // force reflow per ri-startare l'animazione su click ravvicinati
    void host.offsetWidth;
    host.classList.add('product-bubble--clicked');
    window.setTimeout(function () {
      host.classList.remove('product-bubble--clicked');
    }, 720);
  }

  document.addEventListener('click', function (e) {
    var host = findBubbleHost(e.target);
    if (!host) return;
    if (!prefersReducedMotion) {
      flashBubble(host);
    }
    playChime();
  }, true);

  /* ── Inietta data-magic-sparkle sui link prodotto ─────────────────
     così magic.js (già caricato) lancia il burst di scintille al click. */
  function annotateProductLinks() {
    var links = document.querySelectorAll('.product-card__link');
    for (var i = 0; i < links.length; i++) {
      if (!links[i].hasAttribute('data-magic-sparkle')) {
        links[i].setAttribute('data-magic-sparkle', '');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', annotateProductLinks);
  } else {
    annotateProductLinks();
  }

  // Re-annotate quando vengono aggiunti card via JS (collection load-more, ecc.)
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          annotateProductLinks();
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
